import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

const labelCls =
  "text-zinc-500 text-xs font-bold uppercase tracking-[0.15em]";
const textareaCls =
  "mt-1 bg-[#0A0A0A] border-[#262626] focus:border-[#007AFF] text-white min-h-[80px] resize-none";

export default function AnamnesiMedicalSection({ form, onChange }) {
  return (
    <>
      <p className="label-overline mb-3">DATI MEDICI E OBIETTIVI</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
        <div>
          <Label className={labelCls}>Patologie</Label>
          <Textarea
            value={form.pathologies}
            onChange={(e) => onChange("pathologies", e.target.value)}
            className={textareaCls}
            data-testid="anamnesi-pathologies"
          />
        </div>
        <div>
          <Label className={labelCls}>Allergie</Label>
          <Textarea
            value={form.allergies}
            onChange={(e) => onChange("allergies", e.target.value)}
            className={textareaCls}
            data-testid="anamnesi-allergies"
          />
        </div>
        <div>
          <Label className={labelCls}>Obiettivi</Label>
          <Textarea
            value={form.objectives}
            onChange={(e) => onChange("objectives", e.target.value)}
            className={textareaCls}
            data-testid="anamnesi-objectives"
          />
        </div>
        <div>
          <Label className={labelCls}>Note Mediche</Label>
          <Textarea
            value={form.medical_notes}
            onChange={(e) => onChange("medical_notes", e.target.value)}
            className={textareaCls}
            data-testid="anamnesi-medical_notes"
          />
        </div>
      </div>
    </>
  );
}
